const getRandomArbitrary = (min: number, max: number) => Math.random() * (max - min) + min;

const getWinnerAngle = (index: number, sectorAngle: number, entries: any) => {
  const i = entries.length * 2 - index;
  return (i * sectorAngle) - (sectorAngle / 2);
};

const TOTAL_NUMBER_OF_ROTATIONS = 5;

interface InitiateSpinProps {
    angle: any;
    entries: any;
    setanimate: any;
    totalAngle: any;
    winnerIndex: any;
}
export const initiateSpin = ({ angle, totalAngle, setanimate, winnerIndex, entries }: InitiateSpinProps) => {
  angle.current = 0;
  const pi = Math.PI;
  totalAngle.current = 0;
  const oneFullRotation = 2 * pi;
  const sectorAngle = (2 * pi) / entries?.length;

  setanimate({});

  const winnerAngleInRadians = TOTAL_NUMBER_OF_ROTATIONS
        * oneFullRotation
        + getWinnerAngle(winnerIndex.current, sectorAngle, entries);
  const winnerAngleInDegrees = ((winnerAngleInRadians * 180) / pi);
  const randomOffset = getRandomArbitrary(0.05, 0.1);
  setanimate({
    rotate: [0, winnerAngleInDegrees + randomOffset],
    transition: {
      duration: 7, ease: [0.25, 0.1, 0.25, 1.0]
    }
  });
};
